export default __webpack_public_path__ + "static/media/maquina-banner-home.a25a87b9.png";